export default __webpack_public_path__ + "static/media/step-error-icon.4e4f1bff.svg";